import { ITag } from '@fluentui/react';
import { DocumentNode } from 'graphql';
import React from 'react';

import Collapsible from './Collapsible';

import { IGenericFilterTag } from '../../../utils/types/IGenericFilterTag';
import GenericChecklist from './GenericChecklist';

export interface IChecklistImplementationProps {
  onSelectedItems?: (selectedItems: IGenericFilterTag) => void;
  initialValues?: IGenericFilterTag;
  disabledValues?: IGenericFilterTag;
  label: string;
  dataKey: string;
  options?: ITag[];
  query?: DocumentNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mapData?: (data: any) => ITag[];
  showSearch?: boolean;
}

const GenericCollapsibleChecklist = (props: IChecklistImplementationProps): JSX.Element => {
  const {
    onSelectedItems,
    initialValues,
    label,
    dataKey,
    disabledValues,
    options,
    query,
    mapData,
    showSearch,
  } = props;

  const onCheckChanged = (tagItems: ITag[]): void => {
    onSelectedItems({
      dataKey,
      title: label,
      values: tagItems,
    });
  };

  return (
    <Collapsible text={label}>
      <GenericChecklist
        items={options}
        query={query}
        mapData={mapData}
        onCheckChanged={onCheckChanged}
        selections={initialValues?.values ?? []}
        disabledItems={disabledValues?.values ?? []}
        showSearch={showSearch}
      />
    </Collapsible>
  );
};

export default GenericCollapsibleChecklist;
